import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { MyBetsTrackingEffects } from './effects/my-bets-tracking.effects';
import { MyBetsTrackingService } from './services/my-bets-tracking.service';

@NgModule({
    imports: [EffectsModule.forFeature([MyBetsTrackingEffects])],
    declarations: [],
    exports: [],
    providers: [MyBetsTrackingService],
})
export class MyBetsTrackingModule {}
